import { useMutation } from '@tanstack/react-query';
import { useApi } from '../../api/api-context';
import { z } from 'zod';
import { plaidLinkTokenResponseSchema } from './use-create-link-token';
// plaid link token update request schema
export const plaidLinkTokenUpdateRequestSchema = z.object({
    plaidItemId: z.string().uuid(),
});
/**
 * Hook for creating a Plaid link token in update mode to fix errored items
 */
export const useCreateUpdateLinkTokenApi = (mutationConfig) => {
    const api = useApi();
    const { onSuccess, onError, ...restConfig } = mutationConfig || {};
    const plaidUpdateLinkTokenApi = async (request) => {
        const response = await api.post('/plaid/link-token-update', request);
        return plaidLinkTokenResponseSchema.parse(response.data);
    };
    return useMutation({
        onSuccess: (...args) => {
            onSuccess?.(...args);
        },
        onError,
        ...restConfig,
        mutationFn: plaidUpdateLinkTokenApi,
    });
};
